export { default } from "./personalizedModule";
